import { Component, OnInit,ViewChild,ElementRef,HostListener,AfterViewInit } from '@angular/core';
import { AppService } from '../../app.service';
import { ConstantConfigService} from '../../services/constant-config.service';
import { SignImageService} from '../../services/sign-image.service';
import {AuthenticationService} from '../../services/authentication.service';
import { GeneralService } from '../../services/general.service';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import { JwtHelperService } from "@auth0/angular-jwt";
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import parseJson  from 'parse-json';
import { Router, ActivatedRoute,NavigationExtras } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';


const helper = new JwtHelperService();
@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss']
})
export class HeaderComponent implements OnInit {
  navigationExtras: NavigationExtras = {
  };
  @ViewChild('switchOpen',{static: true}) switchOpen: ElementRef;
  token="";
  maCurrentTheme: string;
  maThemes: Array<string>;
  appShortcuts: Array<any>;
  tasks: Array<any>;
  signData : any[] = [];
  notifications: Array<any>;
  mobileSearchActive: boolean = false;
  imgUrl : string;
  showSaveBtnFreeFlow : boolean= false ;
  enableSaveBtn : boolean ;
  showSignComponentBtn : boolean;
  continueBtn : string;
  cancel_btn : boolean = false;
  aprroveStatus : boolean = false;
  images : any;
  showMobileThumbnail : boolean;
  active_pageId : number;
  full_name : string;
  tooltipText : string;
  _accessToken : any;
  _domain:any;
  decodedToken : any;
  show_cancel_btn : boolean = false;
  client_session : string;
  changeMobileClass:boolean = false;
  screenWidth: number;
  screenHeight:number;
  constructor(public service: AppService,
    private signService: SignImageService,
    private authService : AuthenticationService,
    private toastr: ToastrService,
    private location: Location,
    private router: Router,
    private cookieService: CookieService,
    private generalService : GeneralService
    ) {
      this.getScreenSize();
    this.imgUrl = ConstantConfigService.ImageUrl;
    this._accessToken = ConstantConfigService.accessToken;
    this._domain = ConstantConfigService.AngularUrl;

    // Retrieve current theme from AppService
    //this.maCurrentTheme = service.maTheme;

    // App shortcut data
    this.appShortcuts = [
      {
        appTitle: 'Calendar',
        className: 'bg-red',
        icon: 'zmdi-calendar'
      },
      {
        appTitle: 'Files',
        className: 'bg-blue',
        icon: 'zmdi-file-text'
      },
      {
        appTitle: 'Email',
        className: 'bg-teal',
        icon: 'zmdi-email'
      },
      {
        appTitle: 'Reports',
        className: 'bg-blue-grey',
        icon: 'zmdi-trending-up'
      },
      {
        appTitle: 'News',
        className: 'bg-orange',
        icon: 'zmdi-view-headline'
      },
      {
        appTitle: 'Gallery',
        className: 'bg-light-green',
        icon: 'zmdi-image'
      }
    ]

    // Available themes
    this.maThemes = [
        'green',
        'blue',
        'red',
        'teal',
        'cyan',
        'blue-grey',
        'purple',
        'indigo'
    ]

    // Tasks
    this.tasks = [
      {
        name: 'HTML5 Validation Report',
        completed: 95,
        color: 'primary'
      },
      {
        name: 'Google Chrome Extension',
        completed: '80',
        color: 'success'
      },
      {
        name: 'Social Intranet Project',
        completed: '20',
        color: 'warning'
      },
      {
        name: 'Bootstrap Admin Template',
        completed: '60',
        color: 'danger'
      },
      {
        name: 'Youtube Client App',
        completed: '80',
        color: 'info'
      }
    ]

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
  }

  goToHome(){
    window.location.href =this._domain+"overview";
  }

  // Set theme
  setMaTheme() {
    this.service.maTheme = this.maCurrentTheme
  }
  shownSideBar : boolean = false;
  security_mode : boolean = false;
  link_expire : boolean = false;
  user_email="";
  company_id="";
  company_id_check;
  switchSubmit:boolean=true;
  showSignatureButton : boolean = false;
  cancel_btn_edit : boolean = false;
  preview_btn : boolean = false;
  preview_btn_text : string = 'Preview';
  update_document : boolean = false;
  buttonLabel : string = "";
  headerData : any = {};
  //headerColor : string ="#014656";
  headerColor : string ="#fff";
  //headergradient='linear-gradient(180deg, #F7FAFC, #ffffff)';
  hideTopLogged:boolean=true;
  preview_show_edit : boolean = false;
  hideTopNotiications:boolean=true;
  showOnlyClose:boolean=false;
  logo = "";
  cancelbtnText: string = 'Cancel';
  buttonActive = false;
  showIcon = false;
  show_header_signature = true;
  displaycls = true;
  source_location;
  show_quick_sign_cancel = false;
  issignpage:boolean=false;
  send_doc_button:boolean=false;
  pendingImages:boolean=false;
  send_doc_text = "Send Doc";
  checkSignOndoc :boolean=false;
  action_flow_new="";
  finish_click = false;
  ngOnInit() {
    // After approve remove thubnail hamburger
    this.signService.data.invokeApproveFinishTrue.subscribe(data => {
      this.service.mobileSidebarActive =  false;
    });
    this.signService.
        data.invokeSignFinishTrue.subscribe(data => {
          this.finish_click = true;
          this.service.mobileSidebarActive =  false;
    });

    this.signService.
        data.invokeSignFinishFalse.subscribe(data => {
          this.finish_click = false;
    });
    this.source_location =  this.cookieService.get('source_location');
    if(typeof this.source_location!="undefined" && this.source_location!=null && this.source_location!="" && this.source_location!="null" && this.source_location=="crm"){
      this.show_quick_sign_cancel = true;
    }else{
      this.show_quick_sign_cancel = false;
    }
    this.signService.data.invokeShowIcon.subscribe(data => {
      this.showIcon = true;
    });
    this.signService.data.invokeActiveButtonNext.subscribe(data => {
      this.buttonActive = true;
    });
    this.signService.data.invokeActiveButtonNextActive.subscribe(data => {
      this.buttonActive = false;
    });

    this.signService.data.invokeFinishFunction.subscribe(data => {
      this.continueBtn  = "Finish";
    });
    this.signService.data.invokeDealHub.subscribe(data => {
      this.show_header_signature  = false;
    });

    this.signService.data.invokeSendDocDisbaled.subscribe(data => {
      this.pendingImages = false;
    });

    this.signService.data.invokeSignDocDrop.subscribe(data => {
      this.checkSignOndoc = false;
      this.send_doc_text = "Finish";
    });

    this.signService.data.invokeSendDocBtnFalse.subscribe(data => {
      this.send_doc_button = false;
    });

    this.signService.data.invokeSendDocBtnTrue.subscribe(data => {
      this.send_doc_button = true;
    });

    var fullRoute = this.router.url;
    if (fullRoute.indexOf('free-flow') > -1 || fullRoute.indexOf('viewdoc') > -1 || fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('viewdoc') > -1 || fullRoute.indexOf('signature') > -1 || fullRoute.indexOf('sign') > -1 || fullRoute.indexOf('doc-comments') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('download') > -1 || fullRoute.indexOf('preview-document') > -1 || fullRoute.indexOf('prefill-request') > -1 || fullRoute.indexOf('approve-hubspot-properties-updation') > -1){
        //console.log("I am in header");
        this.hideTopLogged=false;
        this.hideTopNotiications=true;
        this.displaycls =false // for shing thumbnail
    }
    if (fullRoute.indexOf('sign') > -1){
      this.issignpage = true;
    }
    this.checkToken();
    this.signService.data.invokeFirstComponentFunctionSigned.subscribe(data => {
        this.changeMobileClass = true
    });
    this.service.currentStatusBtn.subscribe(message =>
      this.showSaveBtnFreeFlow = message
    )
    this.service.currentMessage.subscribe(message =>
      this.shownSideBar = message
    );
    this.service.enableStatusBtn.subscribe(message =>
      this.enableSaveBtn = message
    )
    this.service.getBtnStatus.subscribe(
      message =>{
        this.showSignComponentBtn = message['status'];
        this.showSignComponentBtn = false;
        this.continueBtn = message['btnText'];
        this.cancel_btn = message['status'];
        this.aprroveStatus = message['approveStatus'];
        if(typeof message['images']!="undefined"){
          this.images = message['images'];
        }
        this.showMobileThumbnail = message['thumbnail_view']
        this.active_pageId = message['active_pageId']
        this.full_name = message['name']
        this.tooltipText = message['tooltipText']
        this.security_mode = message['security_mode']
        this.link_expire = message['link_expired']
        if(message['showOnlyClose'] == true){
          this.cancelbtnText = 'Close';
        }
      }
    )

    this.service.getEditBtnStatus.subscribe(
      message =>{
        //console.log("message",message);
        //if(typeof message!="undefined"){
          this.preview_btn = message['preview'];
          this.preview_btn_text = message['previewBtnText'];
          this.update_document = message['updateTemplate'];
          this.cancel_btn_edit = message['cancel_btn'];
          this.send_doc_button = message['send_doc_button'];
          this.send_doc_text = message['send_doc_text'];
          this.pendingImages = message['pendingImages'];
          this.buttonLabel = message['btnText'];
          this.checkSignOndoc = message['checkSignOndoc']
          this.headerData = message['header'];
          this.preview_show_edit = message['preview_show_edit'];
          this.action_flow_new = message['action_flow'];
        // }else{
        //   this.preview_btn = false;
        //   this.preview_btn_text = "Preview";
        //   this.update_document = false;
        //   this.cancel_btn_edit = false;
        //   this.buttonLabel = "";
        //   this.headerData = {};
        //   this.preview_show_edit = false;
        // }

       //console.log("headerData",this.headerData);
       // if(message['header']!=undefined && message['header']['tmd_data']=='1'){
        if(typeof this.headerData!='undefined' && this.headerData!="" && this.headerData!=null){
          if(typeof this.headerData.headerColor!='undefined'){
            this.headerColor = this.headerData.headerColor;
          }else{
            //this.headerColor = "#014656";
            this.headerColor = "#ffffff";
          }
          if(typeof this.headerData!='undefined' && typeof this.headerData.logo!='undefined'){
            this.logo = this.headerData.logo;
          }else{
            this.logo = "";
          }
        }else{
          //this.headerColor = "#014656";
          this.headerColor = "#ffffff";
        }
      }
    )

    this.service.currentSignatureStatusBtn.subscribe(
      message=>{
        this.showSignatureButton = message;
      }
    )


  }

  isObjectCheck(val): boolean { return typeof val !== 'undefined'; }

  role_name : string = "";
  full_name_user : string = "";
  user_id="";
  is_free_flow:any = 0;
  quickaAction:any = false;
  allowed_quickaction:boolean=false;
  is_paid;
  licensed_user = 0
  plan_payment_status:number=0;
  checkToken(){
    const myToken = localStorage.getItem(this._accessToken);
    if (typeof myToken != "undefined" && myToken != "" && myToken !=null && myToken != "undefined") {
      this.decodedToken = helper.decodeToken(myToken);
      if(typeof this.decodedToken['userdata']!="undefined"){
        //console.log("decodedTokendecodedToken============",this.decodedToken);
        this.user_email = this.decodedToken['userdata']['email'];
        this.company_id_check = this.decodedToken['userdata']['company_id'];
        this.client_session = this.decodedToken['userdata']['client_session'];
        this.full_name_user = this.decodedToken['userdata']['full_name'];
        this.role_name = this.decodedToken['userdata']['role_name'];
        this.role_id = this.decodedToken['userdata']['role_id'];
        this.user_type = this.decodedToken['userdata']['user_type'];
        this.user_id = this.decodedToken['userdata']['id'];
        this.is_paid = this.decodedToken['userdata']['is_paid'];
        this.licensed_user = this.decodedToken['userdata']['is_licensed_user'];
        const myToken = localStorage.getItem(this._accessToken);
        if(typeof this.decodedToken['userdata']!="undefined" && typeof this.decodedToken['userdata']['beta_features']!="undefined"){
          //console.log("userdata=============userdata===============",this.decodedToken['userdata']['beta_features']);
          let beta_features = this.decodedToken['userdata']['beta_features'];
          let enable_for_all_features = this.decodedToken['userdata']['enabled_features'];
          //console.log("beta_features=============",beta_features);
          //console.log("enable_for_all_features=============",enable_for_all_features);
          this.allowed_quickaction = this.signService.checkfeatureallowed(beta_features,enable_for_all_features,'Quick Actions');
          //console.log("allowed_quickaction=============",this.allowed_quickaction);
        }
        if(typeof this.decodedToken.userdata.is_free_flow!="undefined" && this.decodedToken.userdata.is_free_flow!=""){
          //console.log("====is_free_flow====",this.decodedToken.userdata.is_free_flow)
          this.is_free_flow = this.decodedToken.userdata.is_free_flow;
        }else{
          this.is_free_flow = 0;
        }
        // console.log(this.decodedToken['userdata']['email']);
        // console.log(this.decodedToken['userdata']['company_id']);
        // console.log("decodedToken");

        if(typeof this.user_type != 'undefined' && this.user_type == '1'){
          this.plan_payment_status = this.authService.getCompanyPlanStatus();
        }

        if(this.company_id_check != '' && typeof this.company_id_check != 'undefined'){

          /*this.authService.gettopNotifications(this.user_email,this.company_id_check,this.role_id,this.user_id,'1').subscribe(
            data =>{
              if(data['success']==true){
                this.notifications = data['message'];
              } else {
              // console.log(data);
              }
            },
            error =>{

            }
          );*/

        }
      }

    }
  }


  getDisabledBtn(){
    if(typeof this.action_flow_new!="undefined" && this.action_flow_new=="free_flow"){
      if(typeof this.checkSignOndoc!="undefined" && this.checkSignOndoc){
        return true;
      }else{
        return false
      }
    }else if(typeof this.action_flow_new!="undefined" && this.action_flow_new=="quick_flow"){
      if(typeof this.pendingImages!="undefined" && !this.pendingImages){
        return false;
      }else{
        return true;
      }
    }else{
      return true;
    }
  }

  markasRead(){
    this.authService.markNotificationAsRead(this.user_email,this.company_id_check,this.role_id,this.user_id,'1').subscribe(
      data =>{
        console.log('data',data);
        if(data['success']==true){
          this.toastr.success("",data['message']);
          this.notifications = [];
        }else{
          this.toastr.error('', data['message']);
        }
      },
      error =>{
        this.toastr.error('', error.error.error);
      }
    );
  }

  cancelFreeSignQuickSign(){
    this.show_quick_sign_cancel = false;
    this.cookieService.delete('source_location');
    window.location.href =this._domain+"overview";
    //this.router.navigate(['/overview']);
  }
  viewAllNotifications(){
    this.router.navigate(['/notifications']);
  }

  logout(){
    if(typeof this.action_flow_new!="undefined" && this.action_flow_new=="free_flow"){
      window.location.href =this._domain+"free-sign";
    }else if(typeof this.action_flow_new!="undefined" && this.action_flow_new=="quick_sign"){
      window.location.href =this._domain+"quick-sign";
    }else{
      var fullRoute = this.router.url;
      if (fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('deal-hub') > -1 || fullRoute.indexOf('sign') > -1 || fullRoute.indexOf('signature') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('download') > -1 || fullRoute.indexOf('preview-document') > -1 || fullRoute.indexOf('prefill-request') > -1 || fullRoute.indexOf('approve-hubspot-properties-updation') > -1){
          //console.log("I am in header");
          //this.hideTopLogged=false;
          if (window.location !== window.parent.location) {
            //alert("google================");
            this.signService.data.invokeDealHubCancel.emit();
            //window.parent.postMessage(JSON.stringify({"action": "tmd_cancel"}), "*");
            //window.parent.postMessage("tmd_cancel", "*");
          }else{
            //alert("1google================");
            this.router.navigate(['/login']);
          }

      }else{
          //console.log("I logout case");
          this.authService.logout();
      }
    }

    //this.authService.logout();
  }
  approveDisabled = false;
  linkButton(value,id){
    if(value=="showSelectedThumbnail"){
      let data : any = {
        'status':this.showSignComponentBtn,
        "btnText":this.continueBtn,
        "approveStatus":this.aprroveStatus,
        "images":this.images,
        "thumbnail_view":this.showMobileThumbnail,
        "active_pageId":id,
        "name":this.full_name,
        "tooltipText":this.tooltipText
      }
      this.service.setBtnStatusImage(data);
      //this.service.setBtnStatus(data)
    }
    
    this.signService.linkButton(value);
    
  }

  islogin=1;
  companies:any[]=[];
  openSwitch(){
    this.checkEmail();
  }
  checkEmail(){
    this.checkToken();
    this.authService.checkUserExist(this.user_email,"",this.islogin,"").subscribe(
      data =>{
        if(data['success']==false){
          //console.log(data);
        }else{
         // console.log(data);
          this.signService.showModal(this.switchOpen);
          this.companies=data['company_details'];
        }
      },
      error =>{
        this.toastr.error('', error.error.error);
      }
    );
  }

  closeBox(){
    this.signService.closeModal();
  }
  role_id = "";
  company_id_login;
  company_name;
  user_type = "";
  changeUserLogin(company){
  //  console.log("==================");
    console.log(company.company_id);
    if(this.company_id_check==company.company_id){
      this.switchSubmit = true;
    }else{
      this.company_id_login = company.company_id;
      this.authService.getUserCompanyRole(company.user_company_id).subscribe(
        data =>{
          if(data['success']==false){
            //console.log(data);
            this.toastr.error('', data['message']);
          }else{
            this.switchSubmit = false;
            this.role_id = data['message']['0']['id'];
            this.company_name = company.company_name;
            // console.log("Data");
            // console.log(data);
            // console.log("Data");
          }
        },error =>{
          this.toastr.error('', error.error.error);
        }
      );
    }
  }

  switchLogin(){
    var postdata = {
    "email":this.user_email,
    "company_id":this.company_id_login,
    "switch_to":1,
    'role_id':this.role_id
   };
   this.authService.authenticate_switch(postdata).subscribe(
      data =>{
        if(data['token']!=""){
          this.token = data['token'];
          localStorage.removeItem(this._accessToken);
          localStorage.setItem(this._accessToken, this.token);
          this.toastr.success('', "You have successfully logged in " +this.company_name);
          //this.router.navigate(['/home']);
          setTimeout(()=>{
            location.reload();
          }, 1000);
          this.closeBox();
        }else{
          //console.log(data);
          this.toastr.error('', data['message']);
        }
      },error =>{
        this.toastr.error('', error.error.error);
      }
    );
  }

  clientSession : number;
  email : string;
  cookiesData;
  getAdminLogin(){
    this.cookiesData = localStorage.getItem('switch_session');
    var parseDataCokies  = parseJson(this.cookiesData);
    this.clientSession = 1;
    this.decodedToken.userdata.role_id = this.role_id;
    this.decodedToken.userdata.company_id = localStorage.getItem("company_id");
    let postdata = {
      'company_id': parseDataCokies.company_id,
      'email': parseDataCokies.email,
      'role_id': parseDataCokies.role_id,
      'client_session':0
    }
    this.authService.authenticate_switch(postdata).subscribe(
      data=>{
        if(data['token']!=''){
          localStorage.removeItem(this._accessToken);
          localStorage.setItem(this._accessToken, data['token']);
          localStorage.removeItem('switch_session');
          this.router.navigate(['/client-session']);
          setTimeout(() => {
            location.reload();
          }, 1000);
        }
        else{
          console.log(data['message']);
        }
      },
      error=>{
        console.log(error);
      }
    )
  }

  goQuickSignFlow(type){
    this.cookieService.delete('deal_id_quick_flow');
    this.cookieService.delete('free_flow');
    this.cookieService.delete('sender_email_quick_flow');
    this.cookieService.delete('deal_company_id_quick_flow');
    this.cookieService.delete('hubspot_back_button');
    this.cookieService.delete('action_type_quick_flow');
    this.cookieService.delete('action_flow');
    setTimeout(()=>{
      if(type == 2){
        this.cookieService.set('action_type_quick_flow','2',{secure:true, sameSite: 'None'});
      } else if(type == 3){
        this.cookieService.set('action_type_quick_flow','3',{secure:true, sameSite: 'None'});
      } else if(type == 4) {
        this.cookieService.set('action_type_quick_flow','4',{secure:true, sameSite: 'None'});
      } else {
        this.cookieService.set('action_type_quick_flow','2',{secure:true, sameSite: 'None'});
      }
      this.cookieService.set('source_location','dashboard',{secure:true, sameSite: 'None'});
      this.cookieService.set('sender_email_quick_flow',this.user_email,{secure:true, sameSite: 'None'});
      this.cookieService.set('company_id_quick_flow',this.company_id_check,{secure:true, sameSite: 'None'});
      this.cookieService.set('action_flow','1',{secure:true, sameSite: 'None'});
      //this.cookieService.set('dashboard_login','1',{secure:true, sameSite: 'None'});
      window.location.href =this._domain+"quick-sign";
      //this.router.navigate(['/quick-sign']);
    }, 500);


  }



  goFreeFlow(){
    this.cookieService.delete('deal_id_quick_flow');
    this.cookieService.delete('free_flow');
    this.cookieService.delete('sender_email_quick_flow');
    this.cookieService.delete('deal_company_id_quick_flow');
    this.cookieService.delete('hubspot_back_button');
    this.cookieService.delete('action_type_quick_flow');
    this.cookieService.delete('action_flow');
    setTimeout(()=>{
      this.cookieService.set('source_location','dashboard',{secure:true, sameSite: 'None'});
      this.cookieService.set('sender_email_quick_flow',this.user_email,{secure:true, sameSite: 'None'});
      this.cookieService.set('company_id_quick_flow',this.company_id_check,{secure:true, sameSite: 'None'});
      this.cookieService.set('company_user_login','1',{secure:true, sameSite: 'None'});
      this.cookieService.set('is_paid_user',this.is_paid,{secure:true, sameSite: 'None'});
      window.location.href =this._domain+"free-sign";
      //this.router.navigate(['/free-sign']);
    }, 500);

  }

  goForShareTemplate(){
    this.navigationExtras['data'] = {
      'share_template_flag':true,
    }
    this.router.navigate(['/share-template'],this.navigationExtras);
  }
}
